export default __webpack_public_path__ + "static/media/MyEvent_Cust.ef65eab8.svg";